// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy-info-page-container .file-selector-container{margin-bottom:48px}`, "",{"version":3,"sources":["webpack://./src/pages/BuyInfoPage/BuyInfoPage.scss"],"names":[],"mappings":"AACI,kDACI,kBAAA","sourcesContent":[".buy-info-page-container{\n    .file-selector-container {\n        margin-bottom: 48px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
